export const SIGN_IN_QUERY_PARAM = 'signIn';
export const START_ACADEMIC_REGISTRATION_QUERY_PARAM = 'startAcademicRegistration';
export const START_CHECKOUT_QUERY_PARAM = 'startCheckout';
export const AUTOSTART_REF_QUERY_PARAM = 'autostartRef';
